export enum SlackChannels {
  InsureIQActivityStockguard = 'insureiq-activity-stockguard',
  InsureIQActivityHIQSubAgencies = 'insureiq-activity-hiq-sub-agencies',
  InsureIQActivityAll = 'insureiq-activity-all',
  InsureIQData = 'portal-notifications', // lrp/lgm reset messages
}
